
import list from "./list"
export default  {
    namespaced:true,
    modules:{
        list
    }
}